import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { AppLoginRegistrationContainerModel } from '../../../../../models/aggregates/id';
import { ApiResponseModel, ApiVisa } from '../shared';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';

@Injectable({providedIn: 'root'})
export class AppLoginRegistrationService extends BaseApiTemplateService<AppLoginRegistrationContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'iam/user-invitation';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'iam/user-invitation';
    this.httpClient = http;
  }

  inviteUser(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<AppLoginRegistrationContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/send-invite/?tenantCode=${visa.tenantCode}`;
    }
    return this.httpClient.post<ApiResponseModel<AppLoginRegistrationContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  getMobileRegistrationKey(mobileNumber: string, visa: ApiVisa){
    this.apiUrl = `${visa.api_domain_url}${Core2Config.PLATFORM_DOMAIN_URL_PREFIX}app-login-registrations/mobile/registration-key/backoffice-ep?mobileNumber=${mobileNumber}`;
    return this.httpClient.get<ApiResponseModel<AppLoginRegistrationContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }
}